<template>
    <div>
        <transition name="fade"
            v-if="type === 'receive'">
            <div class="coupon-modal-wrapper"
                v-show="isOpen"
                @click.stop="closeModal">

            </div>
        </transition>
        <!-- 领取优惠券界面 -->
        <!-- type	优惠类型，1：立减券，2：折扣券 -->
        <div class="coupon-modal-container"
            :class="{'show':isOpen}"
            v-cloak
            v-if="type === 'receive'">
            <div class="top">优惠券</div>
            <div class="detail-wrapper">
                <div class="each-coupon"
                    v-for="(item) in sortGetableCoupons"
                    :key="item.id">
                    <div class="left">
                        <span class="suffix"
                            v-if="item.type == 1">￥</span>
                        <span class="price"
                            v-text="item.fee"></span>
                        <span class="zhekou"
                            v-if="item.type == 2">折</span>
                    </div>
                    <div class="right">
                        <div class="name text-overflow"
                            v-text="item.name"></div>
                        <div class="date-range">
                            有效期：{{getValidDate(item)}}
                        </div>
                        <div @click="receiveCoupon(item.id)"
                            class="receive-btn"
                            :class="{'no-receive':item.isDraw === 0}">
                            {{item.isDraw?"已领取":"立即领取"}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom"
                @click="closeModal">完成</div>
        </div>
        <!-- 选择优惠券界面 -->
        <div class="coupon-modal-container select"
            :class="{'show':isOpen}"
            v-if="type === 'select'"
            v-cloak>
            <div class="detail-wrapper">
                <div class="each-coupon select"
                    v-for="(item) in data"
                    :key="item.id">
                    <div class="content"
                        @click="chooseCoupon(item)">
                        <div class="left">
                            <span class="suffix"
                                v-if="item.type == 1">￥</span>
                            <span class="price"
                                v-text="item.fee"></span>
                            <span class="zhekou"
                                v-if="item.type == 2">折</span>
                        </div>
                        <div class="right">
                            <div class="name text-overflow"
                                v-text="item.name"></div>
                            <div class="date-range">
                                有效期：{{getValidDate(item)}}
                            </div>
                        </div>
                    </div>
                    <div class="rules"
                        v-if="item.ruleDesc"
                        @click="showMore">
                        <span v-text="item.ruleDesc"
                            class="rule-text"></span>
                        <img src="https://oss.tuoxingwang.com/vaporetto-assets/goods/png/more.png"
                            class="more">
                    </div>
                </div>
                <!-- <p class="c-text"
                    v-if="canNotUseCoupons.length>0">以下优惠券不适用</p>

                <div class="each-coupon select"
                    v-for="(item) in canNotUseCoupons"
                    :key="item.id">
                    <div class="content no-use">
                        <div class="left">
                            <span class="suffix"
                                v-if="item.type === 0">￥</span>
                            <span class="price"
                                v-text="item.text"></span>
                            <span class="zhekou"
                                v-if="item.type === 1">折</span>
                        </div>
                        <div class="right">
                            <div class="name text-overflow"
                                v-text="item.name"></div>
                            <div class="date-range">
                                有效期：{{item.dateRange[0]}}-{{item.dateRange[1]}}
                            </div>
                        </div>
                    </div>
                    <div class="rules"
                        @click="showMore"
                        v-cloak>
                        <span v-text="item.detail"
                            class="rule-text"></span>
                        <img src="https://oss.tuoxingwang.com/vaporetto-assets/goods/png/more.png"
                            class="more">
                    </div>
                </div> -->
            </div>
        </div>

    </div>
</template>

<script>
// type	优惠类型，1：立减券，2：折扣券

export default {
    name: "CouponModal",
    components: {},
    props: {
        data: Array,
        type: String //select->选择优惠券 receive->领取优惠券
    },
    data() {
        return {
            isOpen: false,
            isReceiving: false
        };
    },
    computed: {
        canUseCoupons() {
            return this.data.filter(e => e.canUse);
        },
        canNotUseCoupons() {
            return this.data.filter(e => !e.canUse);
        },
        sortGetableCoupons() {
            //领取优惠券时 吧可领取的放前面
            return this.data.sort((a, b) => {
                return a.isDraw - b.isDraw;
            });
        }
    },
    watch: {},
    updated() {
        let textDoms = [...document.querySelectorAll(".rule-text")];
        textDoms.forEach(e => {
            if (e.offsetHeight > 15) {
                //超出一行了
                e.classList.add("text-overflow");
                e.nextElementSibling.style.display = "block";
            } else {
                e.classList.remove("text-overflow");
                e.nextElementSibling.style.display = "none";
            }
        });
    },
    mounted() {},
    destroyed() {},
    methods: {
        closeModal() {
            this.isOpen = false;
            document.querySelector("html").classList.remove("noscroll");
            window.scrollTo(0, sessionStorage.scrollY || 0);
            this.$emit("closed");
        },
        openModal() {
            const scrollY =
                window.scrollY === undefined
                    ? window.pageYOffset
                    : window.scrollY;
            sessionStorage.scrollY = scrollY;
            this.isOpen = true;
            document.querySelector("html").classList.add("noscroll");
        },
        showMore(event) {
            event.currentTarget.classList.toggle("active");
        },
        chooseCoupon(item) {
            this.$emit("select:coupon", item);
            this.closeModal();
        },
        getValidDate(item) {
            if (item.validityType == 1) {
                return `领取之日起${item.validityDays}天内有效`;
            } else {
                return `${item.startTime} ~ ${item.endTime}`;
            }
        },
        receiveCoupon(couponID) {
            if (this.isReceiving) return;
            this.isReceiving = true;
            this.$axios
                .post(
                    `${window.API.goods.receiveCoupon}/${couponID}?token=${
                        sessionStorage.token
                    }`
                )
                .then(({ data }) => {
                    this.isReceiving = false;
                    if (data.code == 200) {
                        this.$emit("receive:success", couponID);
                        this.$toast("领取成功~");
                    } else {
                        this.$toast(data.msg);
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.isReceiving = false;
                });
        }
    }
};
</script>
<style scoped lang="scss">
.coupon-modal-wrapper {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    background: rgba(0, 0, 0, 0.65);
    z-index: 10000;
}
.coupon-modal-container {
    position: fixed;
    left: 0px;
    bottom: 0;
    width: 100%;
    background: $white;
    z-index: 10001;
    max-height: 100%;
    transform: translate(0, 100%);
    transition: all 0.2s ease-in-out;
    display: flex;
    flex-direction: column;
    height: $modal-height;
    &.select {
        height: 100%;
    }
    &.show {
        transform: translate(0, 0);
    }
    .top {
        padding: 0.6rem 0;
        text-align: center;
        color: #333;
        font-size: 14px;
    }
    .detail-wrapper {
        flex: 1 1 auto;
        overflow: auto;
        .each-coupon {
            margin: 0 auto 0.933333rem;
            width: 9.2rem;
            height: 2.306667rem;
            display: flex;
            align-items: center;
            background: url("https://oss.tuoxingwang.com/vaporetto-assets/goods/png/coupon-back.png")
                0 0 no-repeat;
            background-size: 100% 100%;
            &.select {
                background: transparent;
                flex-direction: column;
                margin: 0.533333rem auto 0;
                height: auto;
                .content {
                    background: url("https://oss.tuoxingwang.com/vaporetto-assets/goods/png/coupon-sp-back.png")
                        0 0 no-repeat;
                    background-size: 100% 100%;
                }
                .content.no-use {
                    background: url("https://oss.tuoxingwang.com/vaporetto-assets/goods/png/coupon-sp-back-grey.png")
                        0 0 no-repeat;
                    background-size: 100% 100%;
                }
            }
            .rules {
                width: 100%;
                font-size: 11px;
                color: $grey4;
                padding: 0.12rem 0.32rem;
                display: flex;
                align-items: center;
                position: relative;
                background: $white;
                @include border1px(border, $grey3);
                border-top: 0;

                &.active {
                    .rule-text {
                        height: auto;
                        overflow: auto;
                        text-overflow: initial;
                        white-space: initial;
                        line-height: 1.6;
                    }
                    .more {
                        transform: rotate(0deg);
                    }
                }
                .rule-text {
                    display: block;
                    width: 96%;
                    white-space: pre-line;
                    word-break: break-word;
                }
                .more {
                    width: 0.36rem;
                    height: 0.36rem;
                    position: absolute;
                    right: 0.266667rem;
                    top: 0;
                    bottom: 0;
                    margin: auto;
                    transition: 0.2s;
                    transform: rotate(180deg);
                }
            }
            .content {
                width: 100%;
                height: 2.306667rem;
                display: flex;
                align-items: center;
            }
            .left {
                text-align: center;
                font-size: 25px;
                color: $white;
                width: 2.4rem;
                .suffix {
                    font-size: 15px;
                }
            }
            .right {
                width: 6rem;
                margin-left: 0.55rem;
                display: flex;
                flex-direction: column;
                .name {
                    font-size: 15px;
                    color: $white;
                }
                .date-range {
                    font-size: 12px;
                    color: rgba(255, 255, 255, 0.65);
                    margin: 0.1rem 0 0.2rem 0;
                }
                .receive-btn {
                    align-self: flex-end;
                    font-size: 10px;
                    color: $white;
                    background: rgba(255, 255, 255, 0.22);
                    width: 1.653333rem;
                    height: 0.533333rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 0.266667rem;
                    pointer-events: none;
                    &.no-receive {
                        @include border1px(border, $white);
                        background: transparent;
                        pointer-events: initial;
                    }
                }
            }
        }
        .c-text {
            margin-top: 0.893333rem;
            margin-bottom: 0.346667rem;
            font-size: 13px;
            color: #666666;
            text-align: center;
            position: relative;
            width: 100%;
            &:before,
            &:after {
                content: "";
                background: #d6d6d6;
                width: 1.6rem;
                height: 1px;
                position: absolute;
                top: 0.2rem;
                left: 0;
                right: 0;
                margin: auto;
            }
            &:before {
                transform: translateX(-2.88rem);
            }
            &:after {
                transform: translateX(2.88rem);
            }
        }
    }
    .bottom {
        width: 100%;
        height: 1.333333rem;
        background: linear-gradient(
            90deg,
            rgba(255, 150, 0, 1) 0%,
            rgba(255, 120, 0, 1) 100%
        );
        text-align: center;
        line-height: 1.333333rem;
        color: $white;
        font-size: 16px;
    }
}
</style>

